import { render, staticRenderFns } from "./modalExamenLaboratorio.vue?vue&type=template&id=661b30b8"
import script from "./modalExamenLaboratorio.vue?vue&type=script&lang=js"
export * from "./modalExamenLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports